import { packsClient } from "lib/clients";
import { encrypt } from "lib/e2ee/helper";
import { Asset } from "lib/hooks/usePackAssets";

export const switchAssetMode = async (asset: Asset, sessionKey?: any): Promise<void> => {
  let updatedData: Partial<Asset> = { data: { embedded: !asset.data.embedded }};

  if (asset.enc_data) {
    updatedData.enc_data = await encrypt({ ...asset.data, embedded: !asset.data.embedded }, sessionKey) as string;
  }
  else {
    updatedData.data = { embedded: !asset.data.embedded };
  }

  if (asset.group_id) {
    updatedData.group_id = asset.group_id;
  }

  if (asset.row_id) {
    updatedData.row_id = asset.row_id;
  }

  await packsClient.updateAsset(asset.pack_id, asset.id, updatedData);
}
